"use client";

import { ReactNode } from "react";
import Image from "next/image";
import { usePathname } from "next/navigation";
import { BackButton } from "./(components)/BackButton";
import { Version } from "./(components)/Version";
import authorizationBg from "../../../public/images/authorization-bg.png";
import { useTranslation } from "../../i18n/client";

const Layout = ({ children, params }: { children: ReactNode; params: { lng: string } }) => {
  const { t }: { t: any } = useTranslation(params.lng, "auth");
  const pathname = usePathname();

  const getRedirectUrl = () => {
    if (pathname?.includes("/password-recovery")) {
      return "/sign-in";
    }
    return "/";
  };

  return (
    <div className="min-h-screen bg-gray-100 relative overflow-hidden font-montserrat">
      <div className="hidden lg:block absolute z-0 h-full right-0 top-0 w-full">
        <Image
          src={authorizationBg}
          alt="Authorization background"
          quality={100}
          className="object-cover w-full h-full max-w-max ml-auto"
        />
      </div>

      <div className="relative z-10 flex min-h-screen">
        <div className="w-full flex flex-col items-left justify-between gap-8 pt-8 pb-6 px-4 sm:px-8 lg:px-[80px]">
          <BackButton t={t} redirectUrl={getRedirectUrl()} />
          <div className="w-full lg:max-w-[560px]">{children}</div>
          <Version />
        </div>
      </div>
    </div>
  );
};

export default Layout;
